if (!customElements.get('cg-catalogue')) {
  customElements.define('cg-catalogue', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const groups = [...this.querySelectorAll('[data-cg-group]')];
      const buttons = [...this.querySelectorAll('[data-cg-category]')];
      const results = this.querySelector('[data-cg-results]');
      const select = (category, updateURL = false) => {
        const chosen = groups.find(group => group.dataset.cgGroup === category);
        const key = chosen ? category : 'all';
        groups.forEach(group => { group.hidden = key !== 'all' && group !== chosen; });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.cgCategory === key)));
        const count = chosen ? chosen.dataset.count : this.dataset.total;
        results.textContent = `${count} ${Number(count) === 1 ? 'product' : 'products'}${chosen ? ` · ${chosen.dataset.label}` : ''}`;
        if (updateURL) {
          const url = new URL(window.location.href);
          if (key === 'all') url.searchParams.delete('category');
          else url.searchParams.set('category', key);
          history.replaceState(history.state, '', url);
        }
      };
      buttons.forEach(button => {
        const group = groups.find(item => item.dataset.cgGroup === button.dataset.cgCategory);
        if (group) {
          button.hidden = false;
          button.querySelector('[data-cg-count]').textContent = group.dataset.count;
        }
        button.addEventListener('click', () => select(button.dataset.cgCategory, true));
      });
      this.querySelector('[data-cg-toolbar]').hidden = false;
      select(new URL(window.location.href).searchParams.get('category'));
    }
  });
}
